import { useEffect } from "react";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import {
  FormStateType,
  FormDispatch,
  FormReducer,
  FormFields,
} from "../Helpers/formTypes";
import { clear } from "../Helpers/formFunctions";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";

export function useLocationDropdown(
  filteredLocations: LocationDto[],
  state: FormStateType,
  dispatch: FormDispatch,
  setValue: any
) {
  useEffect(() => {
    const preselectedLocation =
      state.location.id &&
      state.location.id != "-1" &&
      state.location.isLocation;
    if (preselectedLocation) {
      const centers = filteredLocations.filter((l) =>
        state.location.centers.includes(l.id)
      );
      if (centers.length == 1) {
        onLocationSelect(centers[0]);
        return;
      }
    } else {
      const centers = filteredLocations.filter(
        (l) => l.id !== "-1" && !l.isLocation
      );
      const locations = filteredLocations.filter(
        (l) => l.id !== "-1" && l.isLocation
      );
      if (centers.length == 1) {
        onLocationSelect(centers[0]);
        return;
      }
      if (locations.length == 1 && centers.length > 1) {
        onLocationSelect(locations[0]);
        return;
      }
    }
  }, [filteredLocations]);

  const onDoctorSelect = (doctor: DoctorDto) => {
    clear(FormFields.appointment, dispatch, setValue);
    setValue(FormFields.doctor, doctor);
    dispatch({
      type: FormReducer.update,
      field: FormFields.doctor,
      payload: doctor,
    });
  };

  const onLocationSelect = (location: LocationDto) => {
    setValue(FormFields.location, location);
    dispatch({
      type: FormReducer.update,
      field: FormFields.location,
      payload: location,
    });
  };

  return {
    onLocationSelect,
    onDoctorSelect,
  };
}
